export const VISIME_UI_LANGUAGE_KEY = 'visime_ui_language';

export const VISIME_LANGUAGE_CHANGED = 'visime_language_changed';

export function getApiLanguage(): string {
  if (typeof window === 'undefined') {
    return 'en';
  }
  const v = localStorage.getItem(VISIME_UI_LANGUAGE_KEY);
  if (v === 'de' || v === 'en') {
    return v;
  }
  return 'en';
}
